export const KEY_LIST_LISTING = "listListing";
export const KEY_DETAIL_LISTING = "detailListing";
export const KEY_SIMILAR_LISTING = "similarListing";
export const KEY_SIMILAR_LISTING_FOR_OFFICE = "similarListingForOffice";
export const KEY_LIST_LOCATION = "listLocation";
export const KEY_LIST_HOMEPAGE_LISTING = "homepageListing";
export const KEY_LIST_SPECIFIC_OFFICE_LISTING = "specificOfficeListing";